export type ServopaFilterInput = Record<string, unknown> | undefined;

const splitStatuses = (raw: string): string[] =>
  raw
    .replace(/[()]/g, "")
    .split(",")
    .map((status) => status.trim())
    .filter(Boolean);

export const extractServopaStatuses = (filter: ServopaFilterInput): string[] | null => {
  if (!filter) return null;

  if (Array.isArray(filter.status_in)) {
    return (filter.status_in as unknown[])
      .map((status) => (typeof status === "string" ? status.trim() : ""))
      .filter(Boolean);
  }

  if (typeof filter["status@in"] === "string") {
    return splitStatuses(filter["status@in"] as string);
  }

  if (typeof filter.status === "string") {
    const rawStatus = filter.status as string;

    if (rawStatus.startsWith("eq.")) {
      return [rawStatus.slice(3).trim()].filter(Boolean);
    }

    if (rawStatus.includes(",")) {
      return splitStatuses(rawStatus);
    }

    return [rawStatus.trim()].filter(Boolean);
  }

  return null;
};
